import { useEffect, useState } from 'react';

interface UseIsIdleOptions {
  readonly timeout?: number;
}

export const useIsIdle = ({ timeout = 2000 }: UseIsIdleOptions = {}): boolean => {
  const [isIdle, setIsIdle] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    let cancelled = false;
    const markIdle = () => {
      if (!cancelled) {
        setIsIdle(true);
      }
    };
    if (typeof window.requestIdleCallback === 'function') {
      const handle = window.requestIdleCallback(markIdle, { timeout });
      return () => {
        cancelled = true;
        if (typeof window.cancelIdleCallback === 'function') {
          window.cancelIdleCallback(handle);
        }
      };
    }
    const handle = window.setTimeout(markIdle, timeout);
    return () => {
      cancelled = true;
      window.clearTimeout(handle);
    };
  }, [timeout]);

  return isIdle;
};
